import axios from 'axios'
import { local, session } from 'store2'
import { url } from './url_service'

const TOKEN_EXPIRATION_KEY = '__oauth-admin-token-expires__'

class OAuthAdminService {

  _me: any

  constructor() {
    this._me = null
  }

  get data() {
    return this._me
  }

  logged() {
    let expires = local.get(TOKEN_EXPIRATION_KEY, 0)
    return expires > 0 && expires - Date.now() > 10000
  }

  // refreshNeeded() {
  //   let expires = local.get(TOKEN_EXPIRATION_KEY, 0)
  //   return expires > 0 && expires - Date.now() < 10000
  // }

  async requestCodeUrl() {
    const response = await axios.get(url.create(`/admin/oauth/code_url`))
    //$storage.setItem(TOKEN_EXPIRATION_KEY, (Date.now() + (response.data.ttl * 1000)).toString())
    return response.data
  }

  async requestToken(code: string) {
    try {
      const response = await axios.get(url.create(`/admin/oauth/token`), {
        params: {
          code
        }
      })
      local.set(TOKEN_EXPIRATION_KEY, (Date.now() + (response.data.expires_in * 1000)))
      return true
    } catch (error) {
      return false
    }
  }

  // async requestLogoutUrl() {
  //   const response = await axios.get(url.create(`/admin/oauth/logout_url`))
  //   return response.data
  // }

  async logout() {
    await axios.get(url.create(`/admin/oauth/logout`))
    local.remove(TOKEN_EXPIRATION_KEY)
    this._me = null
    return
  }
}

export default OAuthAdminService

// Export oauth
export const oauth = new OAuthAdminService()
